<template>
  <div class="algorithm">
    <el-card shadow="never">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="group-name-title">
            组织名称：
            <span>{{ projectName }}</span>
          </div>
          <div>
            <el-form label-width="100">
              <el-form-item label="切换类型:">
                <el-select v-model="calcValue" placeholder="请选择类型" clearable style="width:calc(100% - 75px)" @change="changeCalcType" :disabled="!resourceId">
                  <el-option v-for="item in calcOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <el-card shadow="never" style="margin-top:20px;">
            <div slot="header" class="clearfix"><span>配置列表</span></div>
            <div style="height: 40vh;overflow: auto;">
              <el-tree
                ref="tree"
                :highlight-current="true"
                :data="algorithmList"
                node-key="resourceId"
                :expand-on-click-node="false"
                :default-expand-all="true"
                :props="defaultProps"
                @node-click="handleNodeClick"
              >
                <template slot-scope="{ node, data }">
                  <el-tooltip effect="dark" :content="node.label" placement="right">
                    <span>{{ node.label }}</span>
                  </el-tooltip>
                </template>
              </el-tree>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" v-if="calcValue == 247">
          <el-card shadow="never" style="max-height: 43vh;">
            <div slot="header" class="clearfix"><span>算法实体</span></div>
            <el-form ref="formEntitys" :model="formEntitys" label-width="80px">
              <el-form-item label="选择名称">
                <el-select v-model="formEntitysId" placeholder="请选择名称" style="width:calc(100% - 29px)" @change="onChangeEntitys">
                  <el-option v-for="(item, index) in entitysOptions" :key="index" :label="item.chineseName" :value="item.id"></el-option>
                </el-select>
                <i class="iconfont icon-bianzu4 addbtn" @click="addEntitys"></i>
              </el-form-item>
              <div class="line"></div>
              <el-form-item label="算法名称"><el-input v-model="formEntitys.chineseName"></el-input></el-form-item>
              <el-form-item label="算法类型"><el-input v-model="formEntitys.kind"></el-input></el-form-item>
              <el-form-item label="公式"><el-input v-model="formEntitys.function"></el-input></el-form-item>
              <el-form-item label="算法备注"><el-input type="textarea" v-model="formEntitys.remarks"></el-input></el-form-item>
              <el-form-item><el-button type="primary" @click="saveConfigStatisticsAlgorithmEntity">保存</el-button></el-form-item>
            </el-form>
          </el-card>
        </el-col>
        <el-col :span="7" v-if="calcValue == 247">
          <el-card shadow="never" style="max-height: 43vh;">
            <div slot="header" class="clearfix"><span>算法参数</span></div>
            <el-form ref="formParams" :model="formParams" :rules="ruleFormParams" label-width="90px">
              <!-- <el-form-item label="组织编号"><el-input v-model="form1.name"></el-input></el-form-item> -->
              <el-form-item label="参数" prop="params"><el-input v-model="formParams.params"></el-input></el-form-item>
              <el-form-item label="执行顺序" prop="sorted"><el-input type="Number" v-model="formParams.sorted"></el-input></el-form-item>
              <el-form-item label="数据表名" prop="source"><el-input v-model="formParams.source"></el-input></el-form-item>
              <el-form-item label="基础/本地" prop="mode">
                <el-select v-model="formParams.mode" style="width:100%">
                  <el-option v-for="(item, index) in modeOptions" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item><el-button type="primary" @click="saveConfigStatisticsAlgorithmParam('formParams')">保存</el-button></el-form-item>
            </el-form>
          </el-card>
        </el-col>
        <el-col :span="7" v-if="calcValue == 247">
          <el-card shadow="never" style="max-height: 43vh;">
            <div slot="header" class="clearfix"><span>算法触发</span></div>
            <el-form ref="formTouch" :model="formTouch" label-width="120px">
              <el-form-item label="触发时间"><el-input v-model="formTouch.triggerTime"></el-input></el-form-item>
              <el-form-item label="部署状态"><el-input v-model="formTouch.state"></el-input></el-form-item>
              <el-form-item label="k8s定时任务名称"><el-input v-model="formTouch.cronjobName"></el-input></el-form-item>
              <el-form-item><el-button type="primary" @click="saveConfigStatisticsAlgorithmTrigger('formTouch')">保存</el-button></el-form-item>
            </el-form>
          </el-card>
        </el-col>
        <el-col :span="20" v-if="calcValue == 248">
          <el-card shadow="never" style="max-height: 43vh;overflow: auto;">
            <div slot="header" class="clearfix"><span>配置计算</span></div>
            <el-form ref="formConfig" :model="formConfig" :rules="ruleFormConfig" label-width="120px">
              <el-form-item label="配置描述" prop="content"><el-input v-model="formConfig.content"></el-input></el-form-item>
              <el-form-item label="配置类型" prop="configType">
                <el-select v-model="formConfig.configType" style="width:100%">
                  <el-option v-for="(item, index) in configTypeOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="redis数据类型" prop="redisDataType">
                <el-select v-model="formConfig.redisDataType" style="width:100%">
                  <el-option v-for="(item, index) in redisDataTypeOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="rediskey" prop="redisKey"><el-input v-model="formConfig.redisKey"></el-input></el-form-item>
              <el-form-item label="hashkey" prop="hashKey"><el-input v-model="formConfig.hashKey"></el-input></el-form-item>
              <el-form-item label="redisvalue" prop="redisValue"><el-input v-model="formConfig.redisValue"></el-input></el-form-item>
              <el-form-item label="顺序" prop="showOrder"><el-input v-model="formConfig.showOrder"></el-input></el-form-item>
              <el-form-item><el-button type="primary" @click="saveComputeConfigurationEntity">保存</el-button></el-form-item>
            </el-form>
          </el-card>
        </el-col>
        <el-col :span="20" v-if="!calcValue">
          <el-card shadow="never" style="max-height: 43vh;text-align: center;"><el-empty description="暂无数据"></el-empty></el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import GROUPAPI from '@/api/group';
import PROJECTAPI from '@/api/project';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      resourceId: '', //当前指标IDresourceId
      currentNodeKey: '',
      formEntitys: {},
      formEntitysId: '',
      formParams: { mode: '' },
      ruleFormParams: {
        params: [{ required: true, message: '参数必填', trigger: 'blur' }],
        sorted: [{ required: true, message: '参数必填', trigger: 'blur' }],
        source: [{ required: true, message: '参数必填', trigger: 'blur' }],
        mode: [{ required: true, message: '参数必填', trigger: 'blur' }]
      },
      ruleFormConfig: {
        content: [{ required: true, message: '参数必填', trigger: 'blur' }],
        content: [{ required: true, message: '参数必填', trigger: 'blur' }],
        configType: [{ required: true, message: '参数必填', trigger: 'blur' }],
        redisDataType: [{ required: true, message: '参数必填', trigger: 'blur' }],
        redisKey: [{ required: true, message: '参数必填', trigger: 'blur' }],
        // hashKey: [{ required: true, message: '参数必填', trigger: 'blur' }],
        redisValue: [{ required: true, message: '参数必填', trigger: 'blur' }],
        showOrder: [{ required: true, message: '参数必填', trigger: 'blur' }]
      },
      formTouch: {},
      formConfig: {},
      calcValue: '',
      calcOptions: [],
      entitysOptions: [],
      modeOptions: [
        {
          label: '基础计算',
          value: 0
        },
        {
          label: '本地计算',
          value: 1
        }
      ],
      algorithmList: [],
      defaultProps: {
        children: 'configResourceTreeVos',
        label: 'resourceName'
      },
      //配置类型
      configTypeOptions: [],
      //redis数据类型
      redisDataTypeOptions: []
    };
  },
  created() {
    //切换类型
    this.getSwitchSearchCodes(10);
    //获取配置类型
    this.getSwitchSearchCodes(8);
    //获取redis数据类型
    this.getSwitchSearchCodes(9);
    //获取指标列表
    this.searchConfigProjectStatistics();
  },
  methods: {
    //获取切换类型
    getSwitchSearchCodes(number) {
      let self = this;
      let params = { codesType: number };

      GROUPAPI.searchCodes(params).then(res => {
        if (res.data.code == 200) {
          switch (number) {
            case 10: {
              self.calcOptions = res.data.data;
              break;
            }
            case 8: {
              self.configTypeOptions = res.data.data;
              break;
            }
            case 9: {
              self.redisDataTypeOptions = res.data.data;
              break;
            }
          }
        }
      });
    },
    //获取指标列表
    searchConfigProjectStatistics() {
      let self = this;
      let params = { entityId: this.projectId };
      PROJECTAPI.searchConfigProjectStatistics(params).then(res => {
        if (res.data.code == 200) {
          self.algorithmList = res.data.data;
          this.$nextTick(function() {
            self.$refs.tree.setCurrentKey(self.resourceId);
          });
        }
      });
    },
    //获取算法实体列表
    searchAlgorithmEntitys() {
      let params = { entityId: this.projectId, resourceId: this.resourceId };
      PROJECTAPI.searchAlgorithmEntitys(params).then(res => {
        if (res.data.code == 200) {
          this.entitysOptions = res.data.data;
          this.entitysOptions.forEach(item => {
            if (item.checked == true) {
              this.formEntitysId = item.id;
              this.onChangeEntitys();
            }
          });
        }
      });
    },
    //查询组织指标已配置算法参数
    searchConfigGroupStatisticsAlgorithmParam() {
      let params = { entityId: this.projectId, resourceId: this.resourceId };
      PROJECTAPI.searchConfigProjectStatisticsAlgorithmParam(params).then(res => {
        if (res.data.code == 200) {
          this.$nextTick(function() {
            if (!res.data.data) {
              this.formParams = {};
            } else {
              this.formParams = res.data.data;
            }
          });
        }
      });
    },
    //查询组织指标已配置算法触发
    searchConfigGroupStatisticsAlgorithmTrigger() {
      let params = { entityId: this.projectId };
      PROJECTAPI.searchConfigProjectStatisticsAlgorithmTrigger(params).then(res => {
        if (res.data.code == 200) {
          if (!res.data.data) {
            this.formTouch = {};
          } else {
            this.formTouch = res.data.data;
          }
        }
      });
    },
    //查询组织配置计算实体
    searchComputeConfiguration() {
      let params = { entityId: this.projectId, resourceId: this.resourceId };
      PROJECTAPI.searchComputeConfiguration(params).then(res => {
        if (res.data.code == 200) {
          if (!res.data.data) {
            this.formConfig = {};
          } else {
            this.formConfig = res.data.data;
          }
        }
      });
    },
    //保存算法实体
    saveConfigStatisticsAlgorithmEntity() {
      let params = this.formEntitys;
      PROJECTAPI.saveConfigStatisticsAlgorithmEntity(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchAlgorithmEntitys();
          this.formEntitys = {};
        }
      });
    },
    //保存指标配置算法参数
    saveConfigStatisticsAlgorithmParam(ruleName) {
      if (!this.formEntitysId) {
        this.$message.warning('请选择实体数据！');
        return false;
      }
      this.$refs[ruleName].validate(valid => {
        if (valid) {
          let params = this.formParams;
          params.val = this.projectId;
          params.resourceId = this.resourceId;
          params.kind = 2;
          params.algorithmId = this.formEntitysId;
          GROUPAPI.saveConfigStatisticsAlgorithmParam(params).then(res => {
            if (res.data.code == 200) {
              this.$message.success('操作成功');
              this.searchConfigGroupStatistics();
              this.searchConfigGroupStatisticsAlgorithmParam();
            }
          });
        } else {
          return false;
        }
      });
    },
    //保存指标配置算法触发
    saveConfigStatisticsAlgorithmTrigger(ruleName) {
      let params = this.formTouch;
      GROUPAPI.saveConfigStatisticsAlgorithmTrigger(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchConfigGroupStatistics();
          this.searchConfigGroupStatisticsAlgorithmTrigger();
        }
      });
    },
    //保存配置计算实体
    saveComputeConfigurationEntity() {
      let params = this.formConfig;
      params.entityId = this.projectId;
      params.resourceId = this.resourceId;
      params.kind = 2;
      params.showOrder = parseInt(params.showOrder);
      GROUPAPI.saveComputeConfigurationEntity(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchComputeConfiguration();
          this.searchConfigProjectStatistics();
        }
      });
    },
    //点击指标列表查询
    handleNodeClick(v) {
      //切换类型选中状态
      this.calcValue = v.computeType || '';
      //赋值当前选中
      this.resourceId = v.resourceId;
      //查询实体列表
      this.changeCalcType();
    },
    //添加算法
    addEntitys() {
      this.formEntitys = {};
      this.formEntitysId = '';
      this.formParams = {};
    },
    //切换当前实体
    onChangeEntitys() {
      this.entitysOptions.forEach(item => {
        if (this.formEntitysId == item.id) {
          this.formEntitys = item;
        }
      });
    },
    //计算类型切换事件
    changeCalcType() {
      this.formEntitys = {};
      this.formEntitysId = '';
      this.formParams = {};
      //离线计算
      if (this.calcValue == 247) {
        this.searchAlgorithmEntitys();
        this.searchConfigGroupStatisticsAlgorithmParam();
        this.searchConfigGroupStatisticsAlgorithmTrigger();
      }
      //配置计算
      if (this.calcValue == 248) {
        this.searchComputeConfiguration();
      }
    }
  }
};
</script>

<style lang="scss">
.algorithm {
  .group-name-title {
    margin: 0px 0px 15px 0px;
    span {
      font-weight: bold;
    }
  }
  .el-card__header {
    font-weight: bold;
    background: #f0f2f5;
    text-align: center;
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: rgb(223, 223, 223);
    margin: 0px auto;
    margin-bottom: 20px;
  }
  .el-button {
    width: 100px;
  }
  .addbtn {
    color: #0261e4;
    font-size: 24px;
    position: relative;
    top: 4px;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/projectalgorithm.vue